import { z } from "zod";

export const envSchema = z.object({
  AUTH0_SPA_CLIENT_ID: z.string(),

  AUTH_CLIENT_ID: z.string(),
  AUTH_GATEWAY_DOMAIN: z.string(),
  AUTH_GATEWAY_OIDC_ISSUER: z.string(),

  AUTH_URL: z.string(),

  COMPONO_APP_URL: z.string(),

  ADMIN_URL: z.string(),
  CANDIDATE_URL: z.string(),
  CLUI_DOMAIN: z.string(),

  // former API_URL
  SHORTLYSTER_API_URL: z.string(),
  EMPLOYER_API_URL: z.string(),
  ENGAGE_API_URL: z.string(),
  INSIGHTS_API_URL: z.string(),
  TRACKYR_API_URL: z.string(),
  EMPLOYER_PUBLIC_API_URL: z.string(),
  API_MANAGEMENT_PATH: z.string(),
  AUTH_CLIENTS_TAB: z.string(),
  EMPLOYER_PUBLIC_API_DOCS_URL: z.string(),
  FEDERATION_GATEWAY_URL: z.string(),
  PUBLIC_CONTRACT_DOCS_URL: z.string().optional(),
  /**
   * The `platform`-contract GraphQL endpoint (see Site.ts).
   *
   * `.min(1)` rather than a bare string: rspack substitutes `""` for anything
   * missing from the dotenv file, and Apollo's HttpLink only falls back to
   * `/graphql` when `uri` is `undefined` — an empty string would silently POST
   * every platform-contract query at the dev server's own document URL.
   */
  FEDERATION_GATEWAY_GRAPHQL_URL: z.string().min(1),

  ENVIRONMENT: z.string(),

  MIXPANEL_TOKEN: z.string(),
  MIXPANEL_PROXY_DOMAIN: z.string().optional(),
  SENTRY_DSN: z.string(),
  ZENDESK_TOKEN: z.string(),
  ZENDESK_TOKENURL: z.string(),

  CRONOFY_CLIENT_ID: z.string(),
  CRONOFY_CLIENT_DATACENTER: z.string(),

  GITHUB_SHA: z.string(),

  NODE_ENV: z.string(),

  APP_SHOW_DEV_VIEW: z.coerce.boolean().default(false),
  APP_SEND_ANALYTICS: z.coerce.boolean().default(false),
  APP_RUN_SENTRY: z.coerce.boolean().default(false),
  APP_RUN_ZENDESK: z.coerce.boolean().default(false),
  APP_RUN_AUTH_CLIENT: z.coerce.boolean().default(false),
  APP_GEN_AI_PROMPT_OVERRIDES: z.coerce.boolean().default(false),
  ENV_IS_PRODUCTION: z.coerce.boolean().default(false),
  HEADLESS_TESTING: z.coerce.boolean().default(false),
  NODE_DEBUG: z.coerce.boolean().default(false),

  LAUNCH_DARKLY_CLIENT_ID: z.string(),

  GEN_AI_AGENT_API_URL: z
    .string()
    .default("https://dummy-gen-ai-agent-url.local"),

  /*
   * Empty when the stage did not deploy chat-ai — PR apps only get it with the
   * `pr app - deploy chat-ai` label. The default must stay falsy: a dummy URL
   * here would let the launcher render whenever the variable is absent rather
   * than merely empty, pointing the widget at a host that does not exist.
   */
  CHAT_AI_URL: z.string().default(""),
});
